import type { BlogCollectionItem, CollectionQueryBuilder, CollectionQueryGroup } from '@nuxt/content';

type BlogQuery = CollectionQueryBuilder<BlogCollectionItem> | CollectionQueryGroup<BlogCollectionItem>;

/**
 * Скрывает статьи с approved: false из списочных выборок только на prod.
 * На local/dev/stage черновики остаются видимыми для проверки.
 */
export const useArticleApprovedFilter = () => {
  const isProd = useRuntimeConfig().public.siteEnvironment === 'prod';

  return <T extends BlogQuery>(query: T): T => {
    if (!isProd) return query;

    // Показываем всё, кроме статей с approved: false (true и незаданное — видимы).
    // ВАЖНО: OR-форма (`approved = true OR approved IS NULL`) в билдере
    // @nuxt/content 3.8.2 возвращает ноль строк, из-за чего блог на prod был
    // пустым. Одиночный предикат `IS NOT false` даёт корректный результат.
    // @ts-expect-error тип SQLOperator в @nuxt/content 3.8.2 не включает 'IS NOT', но SQLite-runtime корректно его выполняет.
    return query.where('approved', 'IS NOT', false) as T;
  };
};
